module.exports = __webpack_public_path__ + "media/images/pricing-page-training-dadb3000.png";